import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var initForm = {
  orderNo: '',
  userNo: '',
  consumerName: '',
  applyTimeRange: {
    start: '',
    end: ''
  },
  auditTimeRange: {
    start: '',
    end: ''
  },
  refundStatus: 1,
  nickname: ''
};
import { cloneDeep } from 'lodash';
import { mapState } from 'vuex';
export default {
  meta: {
    title: '取消订单管理',
    auth: true,
    authorityValue: "store-cancel-manage"
  },
  name: 'cancelOrder',
  data: function data() {
    return {
      activeName: 'stayExamine',
      tab: [{
        label: '待审核',
        type: 'stayExamine',
        limt: 0,
        refundStatus: 1
      }, {
        label: '取消成功',
        type: 'stayReceiv',
        limt: 0,
        refundStatus: 2
      }, {
        label: '取消失败',
        type: 'stayExchange',
        limt: 0,
        refundStatus: 3
      }, {
        label: '全部',
        type: 'afterAll',
        limt: 0,
        refundStatus: ''
      }],
      initForm: initForm,
      form: cloneDeep(initForm),
      request: {
        api: 'cancelList',
        params: cloneDeep(_objectSpread(_objectSpread({}, initForm), this.form))
      },
      switchFalse: false
    };
  },
  computed: _objectSpread({}, mapState('d2admin', {
    menu: function menu(state) {
      return state.permission.routeKey;
    }
  })),
  methods: {
    isShow: function isShow(auto) {
      return this.isBtnGroud(this.menu, auto);
    },
    handleSearch: function handleSearch(values) {
      var params = values;

      if (this.activeName == 'stayExamine') {
        this.$set(params, 'refundStatus', 1);
      }

      if (this.activeName == 'stayReceiv') {
        this.$set(params, 'refundStatus', 2);
      }

      if (this.activeName == 'stayExchange') {
        this.$set(params, 'refundStatus', 3);
      }

      if (this.activeName == 'afterAll') {
        this.$set(params, 'refundStatus', '');
      }

      values = params;
      this.$set(this.request, 'params', values);
      this.$refs.baseTable.loadData();
    },
    getAutoAudit: function getAutoAudit() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.getAutoAudit();

              case 2:
                data = _context.sent;
                _this.switchFalse = data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setAutoAudit: function setAutoAudit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$confirm('是否切换审核状态?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this2.$api.setAutoAudit();

                        case 2:
                          _this2.switchFalse = !_this2.switchFalse;

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getNumber: function getNumber() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.$api.cancelCount();

              case 2:
                data = _context4.sent;
                _this3.tab[0].limt = data.newCount;
                _this3.tab[1].limt = data.agreeCount;
                _this3.tab[2].limt = data.rejectCount;
                _this3.tab[3].limt = data.totalCount;

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    tabClick: function tabClick(l) {
      this.activeName = l.type;
      this.form.refundStatus = l.refundStatus;
      this.handleSearch(this.form);
    },
    handleClick: function handleClick(l) {
      this.activeName = l.name;
      this.form.refundStatus = l.refundStatus;
      this.handleSearch(this.form);
    },
    handleGoRoute: function handleGoRoute(id) {
      if (this.isShow('store-order-management')) {
        this.goRoute('orderDetail', {
          orderId: id
        });
      } else {
        this.$message.error('您没有权限访问');
      }
    }
  },
  mounted: function mounted() {
    this.getAutoAudit();
    this.getNumber();
  }
};